import React from "react";
import DamatexCageCard from "./DamatexCageCard";
import StandaloneSensorCard from "./StandaloneSensorCard";

export default function EnvironmentZone({ controls, actions, onOpenCalibration }) {
  const cage = controls.standalones.damatexCage;
  const li = controls.standalones.lightIntrusion;

  return (
    <div className="zone-container environment-zone">
      <h3 className="zone-title">Environment — Canopy Level</h3>
      <DamatexCageCard
        cage={cage}
        onTogglePresence={(v) => actions.updateStandalone("damatexCage.present", v)}
        onToggleSubSensor={(key, v) => actions.updateDamatexSubSensor(key, v)}
        onCalDateChange={(v) => actions.updateStandalone("damatexCage.lastCalDate", v)}
        onCalNeededChange={(v) => actions.updateStandalone("damatexCage.calibrationNeeded", v)}
        onOpenCalibration={onOpenCalibration}
      />
      <StandaloneSensorCard
        label="Light Intrusion Sensor"
        present={li.present}
        onToggle={(v) => actions.updateStandalone("lightIntrusion.present", v)}
      />
    </div>
  );
}
